import { withFragmentArray } from '@liquorice/gql-utils';
import { A11y, Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import HeroItem, { HERO_ITEM_FRAGMENT } from './HeroItem';

const HeroItems = withFragmentArray(HERO_ITEM_FRAGMENT, (data) => {
  return (
    <Swiper
      modules={[Pagination, A11y, Autoplay]}
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      grabCursor
      pagination={{
        clickable: true,
        horizontalClass: 'custom-pagination',
        bulletClass: 'custom-pagination-bullet',
        bulletActiveClass: 'custom-pagination-bullet-active',
      }}>
      {data.map((event) => {
        return (
          <SwiperSlide style={{ opacity: 1 }} key={event.id}>
            <HeroItem item={event} />
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
});

export default HeroItems;
